import React from 'react';
import {connect} from "react-redux";
import AuthService from "../../../services/AuthService";
import CustomPaper from "../../shared/utils/CustomPaper";
import Alert from "../../shared/utils/Alert";
import moment from "../../shared/utils/moment_fr";
import StarRatingComponent from 'react-star-rating-component';
import RaisedButton from "material-ui/RaisedButton";

class PlansActionSalarie extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            ratingId: 0,
            ratingScore: 0,
            ratingComment: '',

        };
        this.Auth = new AuthService();
        this.getSyntheseData = this.getSyntheseData.bind(this);
        this.noterPlanAction = this.noterPlanAction.bind(this);
    }

    componentDidMount() {
        this.getSyntheseData();
    }

    getSyntheseData() {
        this.Auth.fetch('/societe/synthese')
            .then(res => {
                this.setState({data: res.data})
            });
    }

    noterPlanAction() {
        this.Auth.fetch('/salarie/projet_pro/satisfaction',
            {
                method: 'POST',
                data: {
                    comment: this.state.ratingComment,
                    note: this.state.ratingScore,
                    id_projet: this.state.ratingId
                }
            }).then(
            () => {
                this.getSyntheseData();
                this.setState({ratingId: 0});
            }
        )
    }

    render() {
        return (
            <CustomPaper title="Plans d'action">

                <Alert
                    text="Veuillez attribuer ci-dessous une note de satisfaction pour chacun des plans d'action vous concernant."
                />
                {
                    this.state.data.length > 0 ?
                        this.state.data.map(p =>
                            <div
                                key={p.id}
                                className='row'
                                style={{
                                    marginTop: 10,
                                    paddingTop: 5,
                                    paddingBottom: 5,
                                    border: '1px solid black'
                                }}
                            >
                                <div className='col'>
                                    <label className={'text-primary'}>Projet défini :</label>
                                    <p>{p.projet_pro_defini}</p>
                                    <label className={'text-primary'}>Domaine d'activité visé :</label>
                                    <p>{p.domaine_activite_visee}</p>
                                    <label className={'text-primary'}>Compétence à développer :</label>
                                    <p>{p.competences_a_developper}</p>
                                    <label className={'text-primary'}>Moyen à mobiliser :</label>
                                    <p>{p.moyens_a_mobiliser}</p>
                                </div>
                                <div className='col'>
                                    <label className={'text-primary'}>Echéance :</label>
                                    <p>{p.echeance}</p>
                                    <label className={'text-primary'}>Période de réalisation prévue :</label>
                                    <p>
                                        <span>{moment(p.Date_debut, 'YYYY-MM-DD').format('ll')}</span> - <span>{moment(p.Date_fin, 'YYYY-MM-DD').format('ll')}</span>
                                    </p>
                                    <label className={'text-primary'}>Note de satisfaction :</label><br/>
                                    {
                                        (
                                            moment(p.rea_debut, 'YYYY-MM-DD').isValid() &&
                                            moment(p.rea_fin, 'YYYY-MM-DD').isValid()
                                        )
                                            ?
                                            this.state.ratingId === p.id
                                                ?
                                                <div>
                                                    <StarRatingComponent
                                                        name='rating-edit'
                                                        value={Number(this.state.ratingScore)}
                                                        onStarClick={(nextValue) => this.setState({ratingScore: nextValue})}
                                                    />
                                                    <textarea
                                                        style={{width: '100%'}}
                                                        value={this.state.ratingComment}
                                                        placeholder="Vos appréciations ici"
                                                        onChange={x => this.setState({ratingComment: x.target.value})}
                                                    />
                                                    <RaisedButton
                                                        onClick={() => this.noterPlanAction()}
                                                        primary={true}
                                                        label="Noter"
                                                    />
                                                </div>
                                                :
                                                <div>
                                                    <StarRatingComponent
                                                        editing={false}
                                                        name='rating-score'
                                                        value={Number(p.note_satisfaction_salarie)}
                                                    /><br/>
                                                    {p.commentaire_satisfaction_salarie
                                                    &&
                                                    <div className='bg-dark' style={{
                                                        padding: 5,
                                                        color: '#ffc107',
                                                        fontSize: 12,
                                                        marginBottom: 8
                                                    }}>
                                                        {p.commentaire_satisfaction_salarie}
                                                    </div>
                                                    }

                                                    <RaisedButton
                                                        onClick={() => this.setState({ratingId: p.id})}
                                                        primary={true}
                                                        label="Noter"
                                                    />
                                                </div>
                                            :
                                            <Alert
                                                type='warning'
                                                text="Votre employeur n'a pas encore indiqué la réalisation de ce plan d'action."
                                            />
                                    }
                                </div>
                            </div>
                        ) : <Alert text="Aucun plan d'action n'est encore prévu pour vous." type='warning'/>
                }
            </CustomPaper>
        );
    }
}

function mapStateToProps(store) {
    return {infosSalarie: store.salarie.infos, echeances: store.params.echeances}
}

export default connect(mapStateToProps)(PlansActionSalarie);


// WEBPACK FOOTER //
// ./src/components/salarie/bodies/PlansActionSalarie.js